import { Checkbox, makeStyles } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import classNames from 'classnames'
import React, { FC, memo } from 'react'

const useStyles = makeStyles(theme => ({
  checkboxChecked: {
    color: theme.palette.text.primary
  },
  checkboxUnchecked: {
    color: theme.palette.text.disabled
  },
  hardExcludedCheckbox: {
    position: 'relative',
    '& svg': {
      zIndex: 1
    },
    '&::before': {
      zIndex: 0,
      content: '""',
      position: 'absolute',
      width: 12,
      height: 12,
      backgroundColor: theme.palette.grey[200]
    }
  }
}))

type EnhancedQtyCheckboxProps = {
  onChange: (e: any) => void
  isBooked: boolean
  isBookOpPending: boolean
  isHardExcluded: boolean
  disabled: boolean
}

/**
 * Door-level booking checkbox
 */
const EnhancedQtyCheckbox: FC<EnhancedQtyCheckboxProps> = ({
  onChange,
  isBooked,
  isBookOpPending,
  isHardExcluded,
  disabled
}) => {
  const classes = useStyles()
  return (
    <Checkbox
      onChange={onChange}
      checked={isBooked}
      className={classNames({
        [classes.checkboxChecked]: isBooked,
        [classes.checkboxUnchecked]: !isBooked,
        [classes.hardExcludedCheckbox]: isHardExcluded
      })}
      style={{
        // prevents interaction during optimistic update
        pointerEvents: isBookOpPending ? 'none' : 'all'
      }}
      disabled={disabled} // hard-disabled states, not optmisitic updates - see useEnhancedQuantity
      size='small'
      color='default'
      icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
      checkedIcon={<CheckBoxIcon fontSize='small' />}
    />
  )
}

export default memo(EnhancedQtyCheckbox)
